var $75f34cf3de3b71c1$exports = {};
$75f34cf3de3b71c1$exports = {
    "collectionLabel": `Prijedlozi`
};


export {$75f34cf3de3b71c1$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
